import moment from "moment"
import React, { useState } from "react"
import { CardBody, Col, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import Select, { components } from 'react-select';
import { toast } from "react-toastify"
import ModalPopup from "../../../components/ModalPopup"
import CustomerAdd from "../../customer/CustomerAdd"
import NumberFormat from "react-number-format"
import TextUtils from "../../../helpers/TextUtils"
import ToggleButton from "../../../common/ToggleButton"
import { ValueText } from "../ProductAdd"
import { ProductType } from "../ProductList"
import { WithContext as ReactTags } from 'react-tag-input';
import AsyncSelect from "react-select/async";
import APIClient from "../../../helpers/APIClient";
import { baseUrl } from "../../../constants/environment";
import { MultiSelect } from "react-multi-select-component";

export const usageList: any = [
    {
        label: "Bôi ngoài da",
        value: "on_skin",
    },
    {
        label: "Uống",
        value: "drink",
    },
    {
        label: "Tiêm truyền",
        value: "infusion",
    },
    {
        label: "Khí dung",
        value: "nebulized",
    }
]
// Miếng - Gói - Bịch - Bộ - Cái - Chai - Chiếc - Dây - Combo - Hộp - Vỉ - Cuộn - Lốc - Túi - Ống - Lọ - Thùng - Tuýp - Gam - Ml
export const usedUnits: any = [
    {
        label: "Miếng",
        value: "mieng",
    },
    {
        label: "Gói",
        value: "goi",
    },
    {
        label: "Bịch",
        value: "bich",
    },
    {
        label: "Bộ",
        value: "bo",
    },
    {
        label: "Cái",
        value: "cai",
    },
    {
        label: "Chai",
        value: "cahi",
    },
    {
        label: "Chiếc",
        value: "chiec",
    },
    {
        label: "Dây",
        value: "day",
    },
    {
        label: "Combo",
        value: "combo",
    },
    {
        label: "Hộp",
        value: "hop",
    },
    {
        label: "Vỉ",
        value: "vi",
    },
    {
        label: "Cuộn",
        value: "cuon",
    },
    {
        label: "Lốc",
        value: "loc",
    },
    {
        label: "Túi",
        value: "tui",
    },
    {
        label: "Ống",
        value: "ong",
    },
    {
        label: "Lọ",
        value: "lo",
    },
    {
        label: "Thùng",
        value: "thung",
    },
    {
        label: "Tuýp",
        value: "tuyt",
    },
    {
        label: "Gam",
        value: "gam",
    },
    {
        label: "Ml",
        value: "ml",
    },
    {
        label: "Viên",
        value: "vien",
    },
    {
        label: "Nhát xịt",
        value: "nhat_xit",
    },
    {
        label: "Giọt",
        value: "giot",
    },
]

const ProductInfo = (props: any) => {
    const { data, setData, id, type, onlyView, handleChangeInput, category, brand, origin, validation, age, pathologicals, setLoading, loading } = props;

    const [queryPathologicals, setQueryPathologicals] = useState('');

    
    const handleFilterMulti = (name: string, option: any, onChange: any) => {
        const value: any = []
        option && option?.map((item: any) => {
            value.push(item)
        })
        onChange({ target: { name, value } })
    }

    const getFilterMulti = (list: any, value: any) => {
        if (value instanceof Array) {
            const option: any = []
            list && list?.map((item: any) => {
                const found = value?.length > 0 && value?.find((element: any) => element == item?.value);
                if (found || found === 0) {
                    option.push(item)
                }
            })
            return option
        }
        return []
    }

    const KeyCodes = {
        comma: 188,
        enter: 13
    };

    const delimiters = [KeyCodes.comma, KeyCodes.enter];

    const setTags = (value: any) => {
        handleChangeInput({ target: { name: 'ingredient', value } })
    }

    const handleDelete = (i: any) => {
        const item = data?.ingredient[i]
        setTags(data?.ingredient.filter((tag: any, index: number) => index !== i));
    };

    const handleAddition = (tag: any) => {
        setTags([...data?.ingredient, {
            ...tag,
            name: tag?.text,
        }]);
    };

    const handleTagClick = (index: number) => {
        console.log('The tag at index ' + index + ' was clicked');
    };

    const handleChangePathologicals = (newValue: any) => {
        setQueryPathologicals(newValue);
        return newValue;
    };

    const loadPathologicalsSearchs = async () => {
        setLoading(true)
        let response: any = await APIClient.GET(`${baseUrl}/product/pathologicals`, {
          page: 1,
          limit: 20,
          name: queryPathologicals,
        });
        setLoading(false)
        if (response.response?.data !== undefined) {
          let Arr: any = [];
          response.response?.data?.map((e: any) => {
            Arr?.push({
              value: e?.id,
              label: e?.name,
              ...e,
            });
          });
          return Arr
        }
    };

    const handleMultiSelect = (name: string, option: any, onChange: any) => {
        const value: any = [];
        option &&
          option.map((item: any) => {
            value.push({
              id: item?.id,
              label: item?.label,
              value: item?.id
            });
          });
        if(value?.length > data?.total_use) {
          toast.warning('Người dùng thẻ không được vượt quá số lượng tối đa');
          return
        }
        onChange({ target: { name, value } });
    };
    
    return (
        <PageBody>
            <div className="nutri-title mb-3">Thông tin chung</div>
            <Row>
                <Col md={12} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label><span>*</span>Tên sản phẩm</Label>
                        <InputGroup>
                            <Input type="text" value={data?.name} onChange={(e: any) => handleChangeInput(e)} name="name" placeholder="Nhập tên sản phẩm..." />
                            {validation?.name && <div className="invalid-feedback d-block" >{validation?.name}</div>}
                        </InputGroup>
                    </FormGroup>
                </Col>
                {props?.user?.store_id?.is_erp_stock &&
                    <Col md={4} xs={12}>
                        <FormGroup className='nutri-form'>
                            <Label><span>*</span> SKU ERP</Label>
                            <InputGroup className='d-flex '>
                                <Input type="text" value={data?.erp_sku} onChange={(e: any) => handleChangeInput(e)} name="erp_sku" placeholder="Nhập SKU ERP..." style={{minWidth: 170}} />
                                <InputGroupAddon onClick={() => {
                                    props?.loadInfoProductErp(data?.erp_sku)
                                }} addonType="append" className='d-flex align-items-center' cssModule={{ color: '#48a800' }} style={{ right: -15, top: 5, color: '#48a800', cursor: "pointer" }}>
                                <span style={{ color: '#48a800' }}>Lấy thông tin</span>
                                </InputGroupAddon>
                                {/* 0102041111 */}
                                {validation?.erp_sku && <div className="invalid-feedback d-block" >{validation?.erp_sku}</div>}
                            </InputGroup>
                        </FormGroup>
                    </Col>}
                <Col md={props?.user?.store_id?.is_erp_stock ? 4 : 8} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label><span>*</span>Loại sản phẩm</Label>
                        <Select
                            placeholder={type === 'view' && !data?.product_type ? '---' : "Chọn Loại sản phẩm"}
                            className="react-select mb-2"
                            classNamePrefix="react-select"
                            isDisabled={onlyView}
                            onChange={(val: any) => {
                                // setData({ ...data, product_type: val?.value })
                                handleChangeInput({ target: { name: 'product_type', value: val?.value } })
                            }}
                            value={ProductType?.filter(
                                (option: any) => data?.product_type == option.value
                            )}
                            options={ProductType}
                        ></Select>
                        {validation?.product_type && <div className="invalid-feedback d-block" >{validation?.product_type}</div>}
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label><span>*</span>Danh mục sản phẩm</Label>
                        <Select
                            placeholder={type === 'view' && !data?.category_id ? '---' : "Chọn Loại sản phẩm"}
                            className="react-select mb-2"
                            classNamePrefix="react-select"
                            isDisabled={onlyView}
                            onChange={(val: any) => {
                                // setData({ ...data, category_id: val?.value })
                                handleChangeInput({ target: { name: 'category_id', value: val?.value } })
                            }}
                            value={category?.filter(
                                (option: any) => data?.category_id == option.value
                            )}
                            options={category}
                        ></Select>
                        {validation?.category_id && <div className="invalid-feedback d-block" >{validation?.category_id}</div>}
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label><span>*</span>Độ tuổi</Label>
                        <Select
                            className="react-select mb-2"
                            classNamePrefix="react-select"
                            placeholder="Chọn độ tuổi"
                            options={age}
                            onChange={(val: any) => {
                                setData({
                                    ...data,
                                    product_age_id: val?.value
                                })
                            }}
                            value={age?.filter((option: any) => option?.value == data?.product_age_id)}
                        ></Select>
                        {validation?.product_age_id && <div className="invalid-feedback d-block" >{validation?.product_age_id}</div>}
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Bệnh lý</Label>
                        <AsyncSelect
                            isMulti
                            className="react-select mb-2"
                            classNamePrefix="react-select"
                            onInputChange={handleChangePathologicals}
                            loadOptions={loadPathologicalsSearchs}
                            inputValue={queryPathologicals}
                            placeholder={loading ? "Đang tải dữ liệu..." : "Tìm kiếm bệnh lý"}
                            noOptionsMessage={() => queryPathologicals ? "Không tìm thấy dữ liệu" : 'Tìm kiếm bệnh lý'}
                            loadingMessage={() => 'Đang tìm kiếm...'}
                            cacheOptions
                            style={{ padding: 0 }}
                            isDisabled={onlyView}
                            onChange={(val: any) => {
                                handleMultiSelect('product_pathological_ids', val, handleChangeInput)
                            }}
                            value={data?.product_pathological_ids}
                            defaultOptions={pathologicals}
                            components={{
                                Menu: (props: any) => (
                                    <components.Menu {...props} >
                                    {props.children}
                                    </components.Menu>
                                )
                            }}
                        ></AsyncSelect>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    {/* <FormGroup className='nutri-form'>
                        <Label>Liều dùng</Label>
                        <InputGroup>
                            <Input type="text" value={data?.dosage} onChange={(e: any) => handleChangeInput(e)} name="dosage" placeholder="Nhập liều dùng..." />
                        </InputGroup>
                    </FormGroup> */}
                    <FormGroup className='nutri-form'>
                        <Label>Loại đường dùng</Label>
                        <Select
                            className="react-select mb-2"
                            classNamePrefix="react-select"
                            placeholder="Chọn loại đường dùng"
                            options={usageList}
                            isMulti
                            onChange={(val: any) => { handleFilterMulti('usage', val, handleChangeInput) }}
                            value={data?.usage || []}
                        ></Select>
                    </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label><span>*</span>Đơn vị sử dụng</Label>
                        <Select
                            placeholder={type === 'view' && !data?.used_unit ? '---' : "Chọn đơn vị"}
                            className="react-select mb-2"
                            classNamePrefix="react-select"
                            isDisabled={onlyView}
                            onChange={(val: any) => {
                                handleChangeInput({ target: { name: 'used_unit', value: val?.value } })
                            }}
                            value={usedUnits?.filter(
                                (option: any) => data?.used_unit == option.value
                            )}
                            options={usedUnits}
                        ></Select>
                        {validation?.used_unit && <div className="invalid-feedback d-block" >{validation?.used_unit}</div>}
                    </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label><span>*</span>Đơn vị xuất kho</Label>
                        <InputGroup>
                            <Input type="text" value={data?.minimum_unit} onChange={(e: any) => handleChangeInput(e)} name="minimum_unit" placeholder="Nhập đơn vị..." />
                            {validation?.minimum_unit && <div className="invalid-feedback d-block" >{validation?.minimum_unit}</div>}
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={12} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Thành phần</Label>
                        <ReactTags
                            delimiters={delimiters}
                            tags={data?.ingredient}
                            handleDelete={handleDelete}
                            handleAddition={handleAddition}
                            handleTagClick={handleTagClick}
                            inputFieldPosition="bottom"
                            autocomplete
                            readOnly={type === 'view'}
                            placeholder='Thêm giá trị...'
                        />
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label><span>*</span> Kiểu quản lý</Label>
                        <div className="d-flex align-items-center">
                            <Row style={{ width: '100%' }}>
                                <Col xl={7}>
                                    <div className={data?.type == 'normal' ? "nutri-radio active" : "nutri-radio"} onClick={() => type == 'view' ? {} : setData({ ...data, type: 'normal' })}>
                                        <div className="icon"></div>
                                        <div className="label">Thường</div>
                                    </div>
                                </Col>
                                {!props?.user?.store_id?.is_erp_stock &&
                                    <Col xl={5}>
                                        <div className={data?.type == 'batch' ? "nutri-radio active" : "nutri-radio"} onClick={() => type == 'view' ? {} : setData({ ...data, type: 'batch' })}>
                                            <div className="icon"></div>
                                            <div className="label">Lô</div>
                                        </div>
                                    </Col>}
                            </Row>
                        </div>
                        {validation?.type && <div className="invalid-feedback d-block" >{validation?.type}</div>}
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>SKU</Label>
                        <InputGroup>
                            <Input type="text" value={data?.sku} onChange={(e: any) => handleChangeInput(e)} name="sku" placeholder="Nhập SKU..." />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Mã vạch</Label>
                        <InputGroup>
                            <Input type="text" value={data?.barcode} onChange={(e: any) => handleChangeInput(e)} name="barcode" placeholder="Nhập mã vạch..." />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={12} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Mô tả sản phẩm</Label>
                        <InputGroup>
                            <Input type="textarea" rows={8} value={data?.description} onChange={(e: any) => handleChangeInput(e)} name="description" placeholder="Nhập mô tả sản phẩm..." />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={8} xs={12}>
                    <FormGroup className={type != 'view' ? 'nutri-form placeholder-right1' : 'nutri-form'}>
                        <Label>Chiều dài / Chiều rộng / Chiều cao</Label>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <NumberFormat
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeInput({ target: { name: "longs", value: TextUtils.onlyNumber(e.target.value) } })}
                                name={'longs'} type={'text'} className="form-control"
                                value={type === 'view' && !data?.longs ? '---' : data?.longs}
                                placeholder={(type == 'view' && !data?.longs) ? "---" : "dài..."} thousandSeparator={true}
                            />
                            /<NumberFormat
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeInput({ target: { name: "width", value: TextUtils.onlyNumber(e.target.value) } })}
                                name={'width'} type={'text'} className="form-control"
                                value={type === 'view' && !data?.width ? '---' : data?.width}
                                placeholder={(type == 'view' && !data?.width) ? "---" : "rộng..."} thousandSeparator={true}
                            />
                            /<NumberFormat
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeInput({ target: { name: "height", value: TextUtils.onlyNumber(e.target.value) } })}
                                name={'height'} type={'text'} className="form-control"
                                value={type === 'view' && !data?.height ? '---' : data?.height}
                                placeholder={(type == 'view' && !data?.height) ? "---" : "cao..."} thousandSeparator={true}
                            />
                        </div>

                        <div className="unit">cm</div>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Khối lượng (g)</Label>
                        <InputGroup>
                            <Input type="text" value={data?.weight} onChange={(e: any) => handleChangeInput(e)} name="weight" placeholder="Nhập trọng lượng..." />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={8} xs={12}>
                    <Row>
                        <Col md={6} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label>Thương hiệu</Label>
                                <InputGroup>
                                <Input
                                    type="text"
                                    placeholder={type === 'view' && !data?.brand_text ? '---' : "Nhập thương hiệu"}
                                    className="react-select mb-2"
                                    disabled={onlyView}
                                    onChange={(event) => {
                                        // setData({ ...data, brand_text: event.target.value })
                                        handleChangeInput({ target: { name: 'brand_text', value: event.target.value } })
                                    }}
                                    value={data.brand_text}
                                />
                                 </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col md={6} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label>Xuất xứ</Label>
                                <InputGroup>
                                    <Input
                                        placeholder={type === 'view' && !data?.origin_text ? '---' : "Nhập dữ liệu..."}
                                        className="react-select mb-2"
                                        disabled={onlyView}
                                        onChange={(event) => {
                                            setData({ ...data, origin_text: event.target.value });
                                        }}
                                        value={data.origin_text}
                                    />
                                    {validation?.origin_text && <div className="invalid-feedback d-block" >{validation?.origin_text}</div>}
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label><span>*</span>Trạng thái</Label>
                        <div className="d-flex align-items-center">
                            <Row style={{ width: '100%' }}>
                                <Col xl={8}>
                                    <div className={data?.status == 1 ? "nutri-radio active" : "nutri-radio"} onClick={() => type == 'view' ? {} : setData({ ...data, status: 1 })}>
                                        <div className="icon"></div>
                                        <div className="label">Hoạt động</div>
                                    </div>
                                </Col>
                                <Col xl={4}>
                                    <div className={data?.status == 0 ? "nutri-radio active" : "nutri-radio"} onClick={() => type == 'view' ? {} : setData({ ...data, status: 0 })}>
                                        <div className="icon"></div>
                                        <div className="label">Ẩn</div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        {validation?.status && <div className="invalid-feedback d-block" >{validation?.status}</div>}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                {
                    type == 'view' &&
                    <>
                        <Col md={{ size: 4 }} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label><span>*</span>Trạng thái</Label>
                                {
                                    type != 'view' ?
                                        <div style={{ marginTop: 10 }}>
                                            <ToggleButton elmChecked={data?.status == 1 ? true : false} data={data} setData={(data: any) => setData(data)} name='status' />
                                        </div> :
                                        <ValueText className={data?.status == 1 ? 'text-success' : "text-danger"}>{data?.status == 1 ? 'Đang hoạt động' : "Vô hiệu hóa"}</ValueText>
                                }
                            </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label>Người tạo</Label>
                                <ValueText>{data?.created_uid?.name}</ValueText>
                            </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label>Thời gian tạo</Label>
                                <ValueText>{moment(data?.created_time).format('HH:mm:ss DD/MM/YYYY')}</ValueText>
                            </FormGroup>
                        </Col>
                    </>
                }
            </Row>
        </PageBody>
    )
}

export default ProductInfo